import { find, intersection } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { areIntervalsOverlapping, parseISO, isBefore } from 'date-fns';

class Lieuxvalidation {
  // eslint-disable-next-line space-before-function-paren
  constructor(batiments, codeSilosParDefaut, getLignesPanier) {
    this.batiments = batiments;
    this.codeSilosParDefaut = codeSilosParDefaut;
    this.getLignesPanier = getLignesPanier;
  }

  isLieuValide (codeTypeSilo, numBatiment) {
    const batiment = find(this.batiments, { numBatiment });
    const typesSilo = batiment ? batiment.typesSilo : this.codeSilosParDefaut;
    return !!find(typesSilo, { code: codeTypeSilo });
  }

  validationListLivraison (lignes, checkAgainstItself) {
    let alert = false;
    let error = false;
    let vide = false;

    let lignesPanier = this.getLignesPanier();
    if (checkAgainstItself === true) {
      lignesPanier = lignesPanier.concat(lignes);
    }

    for (const ligne of lignes) {
      const err = this._validationLivraison(ligne, lignesPanier);
      alert = alert || err.alert;
      error = error || err.error;
      vide = vide || err.vide;
    }

    return { alert, error };
  }

  validationLivraison (ligne) {
    return this._validationLivraison(ligne, this.getLignesPanier());
  }

  _validationLivraison (ligne, lignesPanier) {
    let alert = false;
    let error = false;
    let vide = false;

    if (ligne.datePrevueLivraison && ligne.finDatePrevueLivraison && (ligne.codeTypeSilo1 || ligne.codeTypeSilo2 || ligne.codeTypeSilo3)) {
      lignesPanier.forEach(_ligne => {
        if (ligne === _ligne || (ligne.idLigne && ligne.idLigne === _ligne.idLigne)) {
          return;
        }
        const ligneNumAdresse = ligne.numAdr || ligne.numAdresse || ligne.numeroAdresse || ligne.numExploitation || ligne.numeroExploitation;
        const _ligneNumAdresse = _ligne.numAdr || _ligne.numAdresse || _ligne.numeroAdresse || _ligne.numExploitation || _ligne.numeroExploitation;
        if (
          // eslint-disable-next-line eqeqeq
          ligne.numBatiment == _ligne.numBatiment && ligneNumAdresse == _ligneNumAdresse &&
          intersection([ligne.codeTypeSilo1, ligne.codeTypeSilo2, ligne.codeTypeSilo3],
            [_ligne.codeTypeSilo1, _ligne.codeTypeSilo2, _ligne.codeTypeSilo3]).filter(i => i !== undefined && i !== null).length
        ) {
          let dateDebut = parseISO(ligne.datePrevueLivraison);
          let dateFin = parseISO(ligne.finDatePrevueLivraison);

          if (isBefore(dateFin, dateDebut)) {
            [dateDebut, dateFin] = [dateFin, dateDebut];
          }

          if (areIntervalsOverlapping(
            { start: dateDebut, end: dateFin },
            { start: parseISO(_ligne.datePrevueLivraison), end: parseISO(_ligne.finDatePrevueLivraison) },
            { inclusive: true }
          )) {
            // todo : alerte ou erreur selon filiere
            if (ligne.codeFiliere === _ligne.codeFiliere) {
              if (ligne.melangeDechargement === true && _ligne.melangeDechargement === true) {
                // si les deux lignes sont melangées, pas d'alerte
              } else {
                alert = true;
              }
            } else {
              error = true;
            }
          }
        }
      });
    }

    if ((ligne.codeTypeSilo1 === null || ligne.codeTypeSilo1 === undefined) &&
      (ligne.codeTypeSilo2 === null || ligne.codeTypeSilo2 === undefined) &&
      (ligne.codeTypeSilo3 === null || ligne.codeTypeSilo3 === undefined)) {
      vide = true;
    }

    return { alert, error, vide };
  }
}

const mixin = {
  data: () => ({
    $lieuxValidation: null
  }),
  computed: {
    ...mapGetters({
      paramsCommande: 'referentiel/paramsCommande',
      batiments: 'exploitation/batiments',
      cart: 'cart/cart',
      numTiers: 'user/numTiers'
    })

  },
  methods: {
    ...mapActions({
      loadParamsCommande: 'referentiel/loadParamsCommande',
      loadBatiments: 'exploitation/loadBatiments'
    }),
    async $lieuxValidationLoad () {
      if (!this.paramsCommande) {
        await Promise.all([
          this.loadParamsCommande({}),
          this.loadBatiments(this.numTiers)
        ]);
      }
      this.$lieuxValidation = new Lieuxvalidation(this.batiments, this.paramsCommande.typesSiloDefault, () => this.cart);
    }
  }
};

export default mixin;
